// Ambiguity-free alphabet — no I, l, O, 0 or 1, so a password read off a screen
// and typed by hand can't be transcribed wrongly.
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';

/**
 * Suggests a password for the Platform Admin reset modal, e.g. "aB3k-Pq7m-Xy9n".
 *
 * This is a UI convenience only — the operator can overwrite it, and the real
 * controls are the backend's length validation and bcrypt hash. It mirrors the
 * format of generateTempPassword() in backend/src/routes/auth.js, which serves
 * registration; the five lines are duplicated rather than shared to avoid a
 * cross-package dependency.
 */
export function generateTempPassword() {
  let p = '';
  for (let i = 0; i < 12; i++) p += CHARS[Math.floor(Math.random() * CHARS.length)];
  return `${p.slice(0, 4)}-${p.slice(4, 8)}-${p.slice(8, 12)}`;
}
